import { FC, ReactNode } from 'react';
import { Badge } from '@crisellevaldez/speculo-ui';
import { getCallOutcomeStyle, formatOutcome, getOutcomeDescription } from '../../utils/badgeStyles';
import { Tooltip } from './Tooltip';

interface OutcomeBadgeProps {
  /** Raw call outcome value (any casing/format — normalized internally). */
  outcome: string;
  /** Extra classes appended to the badge (sizing, margins, etc.). */
  className?: string;
  /** Optional trailing content inside the badge, e.g. an edit pencil. */
  children?: ReactNode;
}

// A call-outcome badge that reveals the outcome's plain-language meaning on
// hover, using the shared Tooltip so it matches the rest of the app. Color +
// label come from the shared badge utils; the description comes from
// getOutcomeDescription. Outcomes with no known description (out-of-set values)
// render as a plain badge with no tooltip.
export const OutcomeBadge: FC<OutcomeBadgeProps> = ({ outcome, className, children }) => {
  const style = getCallOutcomeStyle(outcome);
  const label = formatOutcome(outcome);
  const description = getOutcomeDescription(outcome);

  const badge = (
    <Badge
      className={`inline-flex items-center gap-1.5 ${style.background} ${style.text} ${className ?? ''}`}
    >
      {label}
      {children}
    </Badge>
  );

  if (!description) return badge;

  return (
    <Tooltip content={description} position="top">
      {badge}
    </Tooltip>
  );
};
